
export interface navPathTypes {
    path: string
    name: string
    icon: string
}

export const nav: navPathTypes[] = [
    { path: "/partnership/",          name: "스폰업체",        icon: 'verified'           },
    { path: "/livebroadcast/",       name: "스포츠 중계",     icon: 'sports-live'        },
    // { path: "/sports/news/",       name: "스포츠 뉴스",      icon: 'community'          },
    // { path: "/sports_news/",       name: "스포츠 뉴스",      icon: 'community'          },
    { path: "/sportsanalysis/", name: "스포츠 분석",     icon: 'sports-analysis'    },
    { path: "/livesports/",         name: "스포츠 정보",     icon: 'sports'             },
    { path: "/livescore/",         name: "스코어 정보",     icon: 'livescore'             },
    { path: "/youtube/highlight/", name: "유튜브",          icon: 'youtube'            },
    { path: "/eventmatch/",      name: "이벤트",          icon: 'event-match'        },
    { path: "/pointexchange/sponmd/",       name: "포인트 전환",     icon: 'point-event'        },
    { path: "/notice/",            name: "공지사항",        icon: 'notice'             },
    // { path: "/sports/special/",    name: "스포츠 스페셜",  icon: 'sports-special'     },
    // { path: "/games/bet/",         name: "포인트 게임",    icon: 'point-game'         },
    // { path: "/community/sports/",  name: "스포츠 뉴스",       icon: 'community'          },
]


export const nav2: navPathTypes[] = [
    { path: "/partnership/",          name: "스폰업체",        icon: 'verified'           },
    { path: "/livebroadcast/",       name: "스포츠 중계",     icon: 'sports-live'        },
    { path: "/sportsanalysis/", name: "스포츠 분석",     icon: 'sports-analysis'    },
    { path: "/livesports/",         name: "스포츠 정보",     icon: 'sports'             },
    
    { path: "chat",         name: "실시간공지",     icon: 'chat'             },

    { path: "/youtube/highlight/", name: "유튜브",          icon: 'youtube'            },
    { path: "/eventmatch/",      name: "이벤트",          icon: 'event-match'        },
    { path: "/pointexchange/sponmd/",       name: "포인트 전환",     icon: 'point-event'        },
    { path: "/livescore/",         name: "스코어 정보",     icon: 'livescore'             },
    
    { path: "home",         name: "메인으로",     icon: 'home'             },
]